import { EstadoAcuerdo } from './../../acuerdo/estado-acuerdo.model';
import { Component, OnInit, Inject } from '@angular/core';
import { Acuerdo } from '../../acuerdo/acuerdo.model';
import { Environment } from '../../../environments/enviroment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { MatPaginatorIntl } from '@angular/material';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { SecurityService } from '../../security/security.service';
import { MediaService } from '../../shared-services/media.service';
import { EnvironmentProvider } from '../../core/browser-providers';

interface Filters {
  page: number;
  size: number;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-ver-acuerdos',
  templateUrl: './ver-acuerdos.component.html',
  styleUrls: ['./ver-acuerdos.component.scss']
})
export class VerAcuerdosComponent implements OnInit {

  cliente: any;
  acuerdosList: Acuerdo[];
  isLoading: boolean;
  totalItems: number;
  public estadoAcuerdo = new EstadoAcuerdo();

  private filters: Filters = {
    page: 0,
    size: 10,
  };

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    public securityService: SecurityService,
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.cliente = data.cliente;
    });
    this.getAcuerdosList();
  }

  async getAcuerdosList() {
    this.acuerdosList = await this.backendService.get(Acuerdo, Acuerdo.path + 'allByCliente/' + this.cliente.id, null).toPromise();
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
  }

  getFilters() {
    return this.filters;
  }

  detallesAcuerdo(id: number) {
    this.router.navigate(['/acuerdos/detalles', id]);
  }

  back() {
    this.router.navigate(['/clientes']);
  }

  onVerPedidos(acuerdo: Acuerdo) {
    this.router.navigate(['/acuerdos/ver-pedidos', acuerdo.id]);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/ver-acuerdos/ver-acuerdos.component.ts